import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const WebhooksRoutes: Routes = [
  {
    path: "webhooks",
    loadComponent: () =>
      import("./webhooks/webhooks.component").then((m) => m.WebhooksComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./webhooks-list/webhooks-list.component").then(
            (m) => m.WebhooksListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./webhooks-form/webhooks-form.component").then(
            (m) => m.WebhooksFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./webhooks-form/webhooks-form.component").then(
            (m) => m.WebhooksFormComponent,
          ),
      },
    ],
  },
];
